export {
  DAY,
  HOUR,
  MINUTE,
  MONTH,
  WEEK,
  YEAR,
} from './relative-time.component';
